<script>
    import { PowerTable } from "@muonw/powertable";
    import countries from "../services/countries.js";
    import { dateText } from "../js/utils.js";
    import { locale, format} from 'svelte-i18n';

    let {
        properties = [],
        ptInstructs = [
            { key: "kind", title: $format("list.columns.kind"), filterable: false },
            { key: "name", title: $format("list.columns.name"), filterable: false },
            {
                key: "value",
                title: $format("list.columns.value"),
                filterable: false,
                parseAs: "unsafe-html",
            },
            { key: "location", title: $format("list.columns.location"), filterable: false },
        ]
    } = $props();

    let ptData = $derived(properties);

    const parseRows = (pageContent) => {
        pageContent.forEach((row) => {
            if(row.kind){
                row.kind = {kind: row.kind}
                if (row.asset_id) row.kind.target_object_type = "asset";
                if (row.finding_id) row.kind.target_object_type = "finding";
                if (row.vulnerability_id)
                    row.kind.target_object_type = "vulnerability";
            }
            if (row.name) {
                row.name = { id: row.id, name: row.name, kind: row.kind.kind };
                if (row.asset_id) row.name.target_object_type = "asset";
                if (row.finding_id) row.name.target_object_type = "finding";
                if (row.vulnerability_id)
                    row.name.target_object_type = "vulnerability";
            }
            if (row["values"]) {
                let data = JSON.parse(row["values"]);
                if (
                    data.hasOwnProperty("location") ||
                    data.hasOwnProperty("country_code")
                ) {
                    let location = data.location
                        ? data.location.toLowerCase()
                        : data.country_code.toLowerCase();
                    row["values"] =
                        `<i class="flag-icon flag-icon-${location}"></i> ${countries.names[data.location ? data.location : data.country_code]}`;
                } else {
                    let str;
                    let strings = Object.keys(data).map((key) =>
                        data[key]
                            ? `${key}: ${" " + data[key]}`
                            : key == "cpe"
                              ? ""
                              : key,
                    );
                    for (let [index, str] of strings.entries()) {
                        if (!strings[index]) {
                            str = strings.splice(index, 1);
                        }
                    }
                    str = strings.join(", ");
                    row["values"] = str;
                }
            }
            if (row["value"]) {
                if (row.kind == "location") {
                    let location = row.value ? row.value.toLowerCase() : "";
                    row["value"] =
                        `<i class="flag-icon flag-icon-${location}"></i> ${countries.names[row.value]}`;
                } else {
                    row.value = {
                        kind: row.kind.kind || row.kind,
                        name: row.name.name || row.name,
                        value: row.value,
                    };
                    if (row.asset_id) {
                        row.value.target_object_type = "asset";
                    } else if (row.finding_id) {
                        row.value.target_object_type = "finding";
                    } else {
                        row.value.target_object_type = "vulnerability";
                    }
                }
            } else {
                row.value = {
                    kind: row.kind.kind || row.kind,
                    name: row.name.name || row.name,
                    value: null,
                    target_object_type: "",
                };
                if (row.asset_id) {
                    row.value.target_object_type = "asset";
                } else if (row.finding_id) {
                    row.value.target_object_type = "finding";
                } else {
                    row.value.target_object_type = "vulnerability";
                }
            }
            if(row["last_discovery_at"]){
                row["last_discovery_at"] = `<span title="${row.last_discovery_at}">${dateText(row["last_discovery_at"])}</span>`;
            }
            if(row["location"]){
                row["location"] = {target_object_type: row.value.target_object_type, name: row.name.name || row.name, location: row.location.includes(",") ? row.location.split(","): row.location};
            }
        });
        return pageContent;
    };

    let ptOptions = $state({
        uniquePrefix: "assetProperties",
        rowsPerPageOptions: [10, 20, 50, 100],
        rowsPerPage: 10,
        footerText: false,
        footerFilters: false,
        footerLoadingBar: false,
        segments: {
            topBar: ["search"],
            pTable: ["table"],
            bottomBar: ["dropdown", "stats", "pagination"],
        },
        translations: {
            add: $format("list.interface.add"),
            delete: $format("list.interface.delete"),
            filterBy: $format("list.interface.filterBy"),
            from: $format("list.interface.from"),
            invertSelection: $format("list.interface.invertSelection"),
            next: $format("list.interface.next"),
            of: $format("list.interface.of"),
            previous: $format("list.interface.previous"),
            rows: $format("list.interface.rows"),
            search: $format("list.interface.search"),
            selectAll: $format("list.interface.selectAll"),
            selectNone: $format("list.interface.selectNone"),
        },
        isDataRemote: false,
        userFunctions: {
            customParse: parseRows,
        },
    });

    const showContent = (kind, id) => {
        let visibleElement = document.getElementById(kind + "-visible-" + id);
        let hiddenElement = document.getElementById(kind + "-hidden-" + id);
        visibleElement.classList.remove("is-visible");
        visibleElement.classList.add("is-hidden");
        hiddenElement.classList.remove("is-hidden");
        hiddenElement.classList.add("is-visible");
    };

    const hideContent = (kind, id) => {
        let visibleElement = document.getElementById(kind + "-visible-" + id);
        let hiddenElement = document.getElementById(kind + "-hidden-" + id);
        visibleElement.classList.add("is-visible");
        visibleElement.classList.remove("is-hidden");
        hiddenElement.classList.add("is-hidden");
        hiddenElement.classList.remove("is-visible");
    };


    window.showContent = showContent;
    window.hideContent = hideContent;
</script>

{#key ptData}
    <PowerTable {ptData} {ptOptions} {ptInstructs}>
        {#snippet noResults()}
                <div >{$format("results_not_found")}</div>
            {/snippet}
    </PowerTable>
{/key}

<style>
</style>
